import React from 'react';
import './App.css';
import { Welcome } from "./components/Welcome";
import { useAppSelector } from "./app/hooks";
import { CommonState } from "./app/interfaces/common";
import { screens } from "./app/data/app";
import { Rules } from "./components/Rules";
import { Game } from "./components/Game";
import { PromoCode } from "./components/PromoCode";
import { Auth } from "./components/Auth";
import { Head } from "./components/Head";
import { Bg } from "./components/Bg";
import { RulesPopup } from "./components/RulesPopup";
import { needShowPromoCode } from "./app/utils/promocode";
import { GamePromoOdePopup } from "./components/GamePromoСodePopup";
import { AuthPopup } from "./components/AuthPopup";
import './assets/scss/styles.scss';
import { FinishedNoText } from "./components/FinishedNoText";
import { Done } from "./components/Done";
import { Finished } from "./components/Finished";
import { Stub } from "./components/Stub";

function App() {
  const { screen, showAlreadyHave, showRules,code, count } = useAppSelector((state: CommonState) => state.app)
  const showPromoCode = needShowPromoCode(code, count)
  const blurBg = showRules || showPromoCode || showAlreadyHave

  const display = (() => {
    switch (screen) {
      case screens.WELCOME:
        return <Welcome/>
      case screens.RULES:
        return <Rules/>
      case screens.AUTH:
        return <Auth/>
      case screens.GAME:
        return <Game/>
      case screens.FINISHED:
        return <Finished/>
      case screens.DONE:
        return <Done/>
      case screens.FINISHED_NO_TEXT:
        return <FinishedNoText/>
      case screens.STUB:
        return <Stub/>
      case screens.PROMO_CODE:
        return <PromoCode/>
    }
  })()
  return (
    <div className={'app'}>
      <div className={'blur-bg ' + (blurBg ? 'blur' : '')}>
        <Bg/>
        <Head/>
        {display}
      </div>
      {showRules && <RulesPopup/>}
      {showPromoCode && <GamePromoOdePopup/>}
      {showAlreadyHave && <AuthPopup/>}
    </div>
  );
}

export default App;
